var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoolsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.892,
    height: 21.771,
    viewBox: "0 0 21.892 21.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pools-icon",
    transform: "translate(0 -1.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10500",
    "data-name": "Group 10500",
    transform: "translate(8.578 9.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10499",
    "data-name": "Group 10499",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40083",
    "data-name": "Path 40083",
    d: "M185.095,182.528h-1.933a1.4,1.4,0,0,0-1.4,1.4v1.933a1.4,1.4,0,0,0,1.4,1.4h1.933a1.4,1.4,0,0,0,1.4-1.4v-1.933A1.4,1.4,0,0,0,185.095,182.528Z",
    transform: "translate(-181.76 -182.528)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10502",
    "data-name": "Group 10502",
    transform: "translate(0 1.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10501",
    "data-name": "Group 10501",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40084",
    "data-name": "Path 40084",
    d: "M21,13.748h-1.3V9.761h1.353a.846.846,0,1,0,0-1.691h-1.3V7.224A3.723,3.723,0,0,0,16.02,3.5h-.846V2.126a.846.846,0,0,0-1.691,0v1.3h-5v-1.3a.846.846,0,1,0-1.691,0v1.3H5.944A3.723,3.723,0,0,0,2.223,7.152V8H.846a.846.846,0,0,0,0,1.691h1.3V13.7H.846a.846.846,0,0,0,0,1.691h1.3v1.764a3.723,3.723,0,0,0,3.721,3.721h.846v1.3a.846.846,0,0,0,1.691,0V20.9h4.953v1.3a.846.846,0,1,0,1.691,0V20.9H15.9a3.723,3.723,0,0,0,3.721-3.721V15.415h1.3a.826.826,0,0,0,.846-.846A.712.712,0,0,0,21,13.748Zm-6.162.072a2.31,2.31,0,0,1-2.3,2.3H9.351a2.31,2.31,0,0,1-2.3-2.3V10.607a2.31,2.31,0,0,1,2.3-2.3h3.19a2.31,2.31,0,0,1,2.3,2.3v3.214Z",
    transform: "translate(0 -1.28)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolsIcon);
export default __webpack_public_path__ + "static/media/pools-icon.c559c7e3228bd749e3e5439c20a433af.svg";
export { ForwardRef as ReactComponent };